import AbstractListResource from './abstract/abstract-list-resource';
import {Resource, ActionType, TrackStatus} from 'sdk/src/defines';
import Track from './items/track';
import {DropDownItem, SortFunc} from '../utility/types';
import {sortAsc} from '../utility/utils';
import {TFunction} from 'react-i18next';

class Tracks extends AbstractListResource<Track> {
    public resourceType: Resource = Resource.TRACKS;

    public resourceItemClass: typeof Track = Track;

    public sort: SortFunc = sortAsc('order');

    public allowedActions: ActionType[] = [
        ActionType.LIST,
        ActionType.GET,
        ActionType.UPDATE,
        ActionType.CREATE,
        ActionType.DELETE,
        ActionType.UPLOAD,
    ];

    public getConnectedResourceTypes(): Resource[] {
        return [Resource.CONTENTS];
    }

    public statusesForDropDown(t: TFunction, empty?: string): DropDownItem[] {
        const result: DropDownItem[] = [];

        if (empty) {
            result.push({
                label: empty,
                value: null,
            });
        }

        result.push(
            {
                label: t('contents.sourceStatusActive'),
                value: TrackStatus.ACTIVE,
            },
            {
                label: t('contents.sourceStatusFailed'),
                value: TrackStatus.FAILED,
            },
            {
                label: t('contents.sourceStatusUnknown'),
                value: TrackStatus.UNKNOWN,
            },
        );


        return result;
    }

}

export {Tracks, Track};

export default new Tracks();
